module.exports = __webpack_public_path__ + "img/ok.0ed3d522.png";